'use strict';

module.exports = function calculateFileName(collaborationModel, fileInfo) {
	const content = collaborationModel.getActiveContent(),
		rootId = content && content.getDefaultRootId(),
		rootNode = content && content.findSubIdeaById(rootId),
		contentTitle = rootNode && rootNode.title;
	return (fileInfo && !fileInfo.free && !fileInfo.new && !fileInfo.legacy && fileInfo.fileId) || contentTitle;
};

